import { formatMoney } from "Helpers/helpFunction";
import { minMaxValue } from "./ChartColumn";

export const options1 = (data: any) => {
  const categories = data?.chartLeft?.category;

  let profitAverage: any = []
  const profitFromBeginning: any = [{ y: data?.detailBacktest?.profitFromBeginning }] || []
  const profitMin: any = data?.chartLeft?.profitMin || []
  const profitMax: any = data?.chartLeft?.profitMax || []
  data?.chartLeft?.profitAverage.filter((item: any, key: any) => {
    if (key === 0) {
      profitAverage.push({
        y: item?.y,
        color: '#2C69B9',
        borderWidth: 2,
        borderColor: '#F7931A',
      });
    } else {
      profitAverage.push({
        y: item?.y,
        color: '#2C69B9',
        borderWidth: 0,
      });
    }
    return item
  })

  let minY = 0
  let maxY = 0

  minY = minMaxValue(profitAverage, minY, maxY).min
  maxY = minMaxValue(profitAverage, minY, maxY).max
  minY = minMaxValue(profitFromBeginning, minY, maxY).min
  maxY = minMaxValue(profitFromBeginning, minY, maxY).max
  minY = minMaxValue(profitMin, minY, maxY).min
  maxY = minMaxValue(profitMin, minY, maxY).max
  minY = minMaxValue(profitMax, minY, maxY).min
  maxY = minMaxValue(profitMax, minY, maxY).max

  const pointWidth = 20
  const dataValue = [
    {
      data: profitAverage,
      color: '#2C69B9',
      pointWidth: pointWidth,
      borderWidth: 0,
    },
    {
      data: profitMin,
      color: '#E31E4D',
      pointWidth: pointWidth,
      borderWidth: 0,
    },
    {
      data: profitMax,
      color: '#00A54F',
      pointWidth: pointWidth,
      borderWidth: 0,
    },
  ];

  return {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      // height: windownWidth
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: categories,
      labels: {
        enabled: true,
        rotation: 0,
        style: {
          color: '#ffffff',
          fontSize: '14px',
        },
      },
      title: {
        text: ''
      },
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
    },
    yAxis: [{
      min: minY - 5,
      max: maxY + 5,
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0.5,
      gridLineColor: '#979797',
      minorGridLineWidth: 0,
      lineWidth: 0,
      title: {
        text: '',
        style: {
          color: '#ffffff'
        }
      },
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '14px',
        }
      }
    }],
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function (item: any) {
        const thisData: any = this
        const index: any = thisData.point.index

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">${thisData.point.category}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt">${formatMoney(thisData.point.y, 2)}%</div>
        </div>`;
      }
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        dataLabels: [{
          enabled: true,
          allowOverlap: true,
          style: {
            textOutline: 'none',
            fontSize: '9px',
            fontWeight: 'bold',
            color: '#ffffff'
          },
          formatter: function (item: any) {
            const thisData: any = this
            return `<div>${formatMoney(thisData.y, 2)}%</div>`;
          }
        }],
      }
    },
    series: dataValue
    // series: []
  }
}